module.exports = __webpack_public_path__ + "static/media/cloud-logo-black.668f2940.svg";